export enum DocumentTypeEnum {
    NetworkRules = 1,
    NetworkProcedures = 2,
    OperatingNoticesAndInstructions = 3,
    NetworkForms = 4,
    RailTrafficOperationsManual = 5,
    NetworkSignalsAndSignsManual = 6,
    Glossary = 7,
    GeneralRules = 10,
    RailTrafficOperations = 11,
    SignallingOperations = 12,
    WorkOnTrack = 13,
    NonMBSTerritory = 15,
    OperatingNotices = 200,
    OperatingInstructions = 300,
    Memos = 400,
    RailControlOperatingInstructions = 500,
    TrackGeneralInstructions = 600,
    TrackEngineeringInstructions = 700,
    SignalingGeneralInstructions = 800,
    WorkInstructions = 900,
    OperatingManuals = 1000,
    ConsultationRulebook = 1001,
    ConsultationDocuments = 1002,
    RailNetworkGuidingPrinciples = 14
}

export const documentTypeDisplay = (val: DocumentTypeEnum | string | undefined) => {

    let type: DocumentTypeEnum = DocumentTypeEnum.NetworkRules;
    if (typeof (val) === 'number') {
        type = val;
    }
    if (typeof (val) === 'string') {
        type = parseInt(val);
    }

    let displayString = DocumentTypeEnum[type]?.replace(/([A-Z])/g, ' $1').trim()

    return displayString;
}
